var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-body"
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "pb-md-6px"
  }, [_c('v-img', {
    attrs: {
      "eager": "",
      "max-width": "115",
      "aspect-ratio": 115 / 54,
      "src": "/images/logo.svg"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "font-weight-medium white--text mb-12px"
  }, [_vm._v("㈜이레아이에스")])]), _c('li', {
    staticClass: "clear"
  }, [_c('span', {
    staticClass: "grey--text text--lighten-3"
  }, [_vm._v("본사 ")]), _vm._v("강원도 강릉시 강릉대로 285,931호")]), _c('li', {
    staticClass: "clear"
  }, [_c('span', {
    staticClass: "grey--text text--lighten-3"
  }, [_vm._v("경기공장 ")]), _vm._v("경기도 안양시 동안구 흥안대로 427번길 16 평촌디지털엠파이어 203호")]), _c('li', {
    staticClass: "clear"
  }, [_c('span', {
    staticClass: "grey--text text--lighten-3"
  }, [_vm._v("전화 ")]), _vm._v("070-8680-0950")]), _c('li', [_c('span', {
    staticClass: "grey--text text--lighten-3"
  }, [_vm._v("팩스 ")]), _vm._v("031-423-0483")]), _c('li', [_c('span', {
    staticClass: "grey--text text--lighten-3"
  }, [_vm._v("이메일 ")]), _vm._v("ireis@ireis.co.kr")])])])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "footer-copyright"
  }, [_c('p', [_vm._v("Copyright 2023. Ireis All Rights Reserved.")])])])], 1)], 1), _c('v-col', {
    staticClass: "d-flex ml-auto",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-row', {
    staticClass: "flex-column",
    attrs: {
      "align-content": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "d-flex"
  }, [_c('v-row', {
    staticClass: "row--sm mt-auto",
    attrs: {
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-small": "",
      "fab": "",
      "color": "grey",
      "href": "https://blog.naver.com/ireis2010",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon icon-blog"
  })])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-small": "",
      "fab": "",
      "color": "grey",
      "href": "https://www.youtube.com/@user-ob6uq3jz6u",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon icon-youtube"
  })])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-small": "",
      "fab": "",
      "color": "grey",
      "href": "https://www.facebook.com/ireis0903",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon icon-facebook"
  })])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-small": "",
      "fab": "",
      "color": "grey",
      "href": "https://www.instagram.com/ireis_official/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "icon icon-insta"
  })])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }